import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-codebook',
	templateUrl: './codebook.component.html',
	styleUrls: ['./codebook.component.css'],
})
export class CodebookComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '';
	protected parentComponent = '';
	private kind = '';
	parentLocationSet = [];
	organization_role: Array<any> = [];
	account_kind: Array<any> = [];
	departments_kind: Array<any> = [];
	service_type: Array<any> = [];
	codebooks = [];
	selectedCodebook;
	protected itemsBeforeDataLoad = 5;

	protected pageTitleGenerate(): string {
		return `Słowniki -> 
			${this.selectedCodebook.name}
			 -> 
			${this.data.name}
			 (ID: 
			${this.data.id}
			)`;
	}

	data = {
		id: null,
		name: null,
	};

	protected convertKind() {
		this.kind = this.route.snapshot.params['kind'];
		this.parentComponent = 'codebook/' + this.kind;
		switch (this.kind) {
			case 'organization_role':
				this.kind = 'organization/role';
				break;
			case 'departments_kind':
				this.kind = 'organization/department_kind';
				break;
			case 'service_type':
				this.kind = 'offer/service_type';
				break;
		}
		this.apiUrlAdd = '/' + this.kind + '/';
	}

	protected loadBefore(): void {
		this.convertKind();
		this.bag.get('/organization/role/', (result, error) => {
			this.organization_role = result.results;
			this.loadData();
		});
		this.bag.get('/account_kind/', (result, error) => {
			this.account_kind = result.results;
			this.loadData();
		});
		this.bag.get('/organization/department_kind/', (result, error) => {
			this.departments_kind = result.results;
			this.loadData();
		});
		this.bag.get('/offer/service_type/', (result, error) => {
			this.service_type = result.results;
			this.loadData();
		});
		this.bag.get('/codebook/?limit=9999', (result, error) => {
			this.codebooks = result.results;

			this.selectedCodebook = this.codebooks.find((item) => item.url == this.route.snapshot.url[1].path);
			this.loadData();
		});
	}

	protected submitAfter(): void {
		this.router.navigate([this.parentComponent]);
	}

	protected getApiUrl(): string {
		this.convertKind();
		return '/' + this.kind + '/' + this.data.id + '/';
	}
}
